import * as Immutable from 'seamless-immutable';
import {
  JSONAPI_CONFIGURE,
  TEMPLATE_CATEGORIES_FETCH_API_FULFILLED,
  TEMPLATE_CATEGORIES_FETCH_START,
  TEMPLATE_CATEGORY_CREATE_API_FULFILLED,
  TEMPLATE_CATEGORY_DELETE_API_FULFILLED,
  TEMPLATE_CATEGORY_UPDATE_API_FULFILLED
} from '../actions';
import {sortAlphabeticallyByPath} from '../../utils/sortingHelpers';
import {TEMPLATE_CATEGORY_FIELD_NAMES} from '../../constants/issue-templates';

const initialState = Immutable.from({
  entitiesMap: {},
  orderedIds: [],
  containerId: null,
  uncategorizedId: null,
  loading: false
});

export default (state = initialState, action) => {
  switch (action.type) {
    case JSONAPI_CONFIGURE:
      return state.merge({containerId: action.payload.containerId});
    case TEMPLATE_CATEGORIES_FETCH_START:
      return state.merge({loading: true});
    case TEMPLATE_CATEGORIES_FETCH_API_FULFILLED: {
      const {results} = action.payload;
      const orderedIds = [];
      const newEntities = {};
      let uncategorizedId = null;
      sortAlphabeticallyByPath(results, TEMPLATE_CATEGORY_FIELD_NAMES.TITLE).forEach(category => {
        newEntities[category.id] = category;
        if (category.containerId === state.containerId) {
          orderedIds.push(category.id);
        } else {
          // Uncategorized category should have a different container ID.
          uncategorizedId = category.id;
        }
      });
      const entitiesMap = {...state.entitiesMap, ...newEntities};
      return state.merge({entitiesMap, orderedIds, loading: false, uncategorizedId});
    }
    case TEMPLATE_CATEGORY_CREATE_API_FULFILLED: {
      const newId = action.payload.id;
      const orderedIds = [newId, ...state.orderedIds];
      const entitiesMap = {...state.entitiesMap, [newId]: action.payload};
      return state.merge({entitiesMap, orderedIds});
    }
    case TEMPLATE_CATEGORY_UPDATE_API_FULFILLED: {
      return state.setIn(['entitiesMap', action.payload.id], action.payload);
    }
    case TEMPLATE_CATEGORY_DELETE_API_FULFILLED: {
      return state.merge({
        entitiesMap: state.entitiesMap.without(action.meta.id),
        orderedIds: state.orderedIds.filter(id => id !== action.meta.id)
      });
    }
    default:
      return state;
  }
};
